import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";

import { ApiService } from 'anatoliapps-angular/services';

import { BlogPost, BlogPostSchema, BlogPostSummary, BlogPostSummarySchema } from 'hakikat/models';
import { API_CONFIG } from "hakikat/utils";

@Injectable({
  providedIn: 'root'
})
export class BlogService extends ApiService {

  //#region Endpoints
  readonly #BLOG_ENDPOINT = 'blog';
  //#endregion

  //#region Constructor
  constructor() { super(API_CONFIG.apiUrl); }
  //#endregion

  //#region Methods
  getBlogPost(id: string): Observable<BlogPost> {
    return this.get<BlogPost>(`${this.#BLOG_ENDPOINT}/post/${id}`).pipe(
      map((response: BlogPost) => BlogPostSchema.parse(response))
    );
  }

  getBlogPostSummaries(): Observable<BlogPostSummary[]> {
    return this.get<BlogPostSummary[]>(`${this.#BLOG_ENDPOINT}/post`).pipe(
      map((response: BlogPostSummary[]) => response.map(post => BlogPostSummarySchema.parse(post)))
    );
  }
  //#endregion
}